import React, { Component } from "react";

import Model from "./Model";

export default class Models extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupedModels: {},
    };
  }

  componentDidMount() {
    if (this.props.modelsapi) {
      var array = {};
      Object.keys(this.props.modelsapi).map((model) => {
        var currentModel = this.props.modelsapi[model].model;
        array = {
          ...array,
          [currentModel]: { ...array[currentModel], [model]: model },
        };
      });
      this.setState(
        {
          groupedModels: array,
        }
      );
    }
  }

  modelSelected(e) {
    this.props.modelSelected(e);
  }

  render() {
    const { models, modelsapi } = this.props;
    const modelCount = Object.keys(models).length;
    if (!models) {
      return "asd";
    }
    return (
      <div className="models" style={{ "--model-count": modelCount }}>
        {Object.keys(models).map((model) => {
          return (
            <Model
              activeModel={this.props.activeModel}
              model={model}
              hasModels={Object.keys(this.state.groupedModels).includes(model)}
              name={model}
              image={models[model].image}
              modelSelected={() => this.modelSelected(model)}
            />
          );
        })}
      </div>
    );
  }
}
